import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../../styles/Buttons.css";
import "../../../styles/Containers.css";
import "../../../styles/Fonts.css";
import "../../../styles/Colors.css";
import "../../../styles/Achievements.css";
import TopNavbarBack from "../../../components/TopNavbarBack";
import { useFetch } from "../../../custom/api";
import account from "../../../media/account.png";
import network from "../../../media/network.png";
import Transaction from "./Transaction";
import AccountEmptyState from "./AccountEmptyState";
import GoToTop from "../../../components/GoToTop";
import { toFarsiNumber } from "../../../custom/helpers";
import AchievementCard from "../../../components/achievements/AchievementCard";
import AchievementModal from "../../../components/achievements/AchievementModal";
import { notifyUnlocked } from "../../../components/achievements/AchievementUnlockToast";

const MAX_FEATURED = 6;

export default function Account() {
  const { myFetch } = useFetch();
  const isLoggedIn = !!localStorage.getItem("token");
  let userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [trackId, setTrackId] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [price, setPrice] = useState("");
  const [planName, setPlanName] = useState("");
  const [transactions, setTransactions] = useState([]);

  const [displayName, setDisplayName] = useState(name);
  const [dClassName, setDClassName] = useState('dNone');

  const [displayEmail, setDisplayEmail] = useState(email);
  const [eClassName, setEClassName] = useState('dNone');

  // Achievements: catalog (with this user's earned/locked + progress) used
  // to power the compact "Achievements" card and the featured-badges editor.
  const [achData, setAchData] = useState(undefined); // undefined = loading
  const [selectedAchievement, setSelectedAchievement] = useState(null);
  const [showFeaturedEditor, setShowFeaturedEditor] = useState(false);
  const [featuredSelection, setFeaturedSelection] = useState([]);
  const [savingFeatured, setSavingFeatured] = useState(false);

  const loadAchievements = async () => {
    const resp = await myFetch("achievements", { method: "GET" });
    const r = await resp.json();
    setAchData(r);
  };

  useEffect(() => {
    if (!isLoggedIn) return;
    const fetchData = async () => {
      const resp = await myFetch("account", { method: "GET" });
      const r = await resp.json();
      setName(r[0].name)
      setDisplayName(r[0].name)
      setEmail(r[0].email || "")
      setDisplayEmail(r[0].email || "")
      setTransactions(r)
    };
    fetchData();
    loadAchievements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log({name, displayName})
    if (name === displayName) {
      setDClassName('dNone')
    } else {
      setDClassName('')
    };

  }, [displayName])

  useEffect(() => {
    if (email === displayEmail) {
      setEClassName('dNone')
    } else {
      setEClassName('')
    };
  }, [displayEmail])

  const setModalData = (transactionId) => {
    let transaction = transactions.filter((e) => {
      return e.transaction_id == transactionId
    })[0]


    let options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };

    let startJalali
    let endJalali

    if (transaction.start_at) {
      startJalali = new Date(transaction.start_at).toLocaleDateString('fa-IR', options);
    } else {
      startJalali = '-'
    }

    if (transaction.end_at) {
      endJalali = new Date(transaction.end_at).toLocaleDateString('fa-IR', options);
    } else {
      endJalali = '-'
    }

    let finalPrice
    if (transaction.verify_amount) {
      finalPrice = toFarsiNumber(transaction.verify_amount / 10000)  + ' هزار تومان'
    }else {
      finalPrice = toFarsiNumber(transaction.price)  + ' هزار تومان'
    }

    setTrackId(toFarsiNumber(transaction.track_id))
    setStartAt(startJalali)
    setEndAt(endJalali)
    setPrice(finalPrice)
    setPlanName(transaction.name_1)
  }

  // Shared PUT account handler for both the name and email inline-save
  // buttons - also the trigger point for the Profile Builder achievement.
  const updateAccount = async (fields) => {
    const resp = await myFetch("account", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(fields),
    });
    const r = await resp.json();
    if (r.status === "success") {
      toast.success("اطلاعات ذخیره شد");
      if (fields.name !== undefined) setName(fields.name);
      if (fields.email !== undefined) setEmail(fields.email);
      if (r.newly_unlocked && r.newly_unlocked.length > 0) {
        notifyUnlocked(r.newly_unlocked);
      }
      loadAchievements();
    } else {
      toast.error(r.message || "مشکلی پیش اومد، دوباره امتحان کن");
    }
  };

  const handleNameChange = (e) => {
    setDisplayName(e.target.value);
  };

  const handleNamePress = (e) => {
    if (e.key === "Enter") {
      sendNameToServer();
    }
  };

  const handleNameClick = () => {
    sendNameToServer();
  };

  const sendNameToServer = () => {
    updateAccount({ name: displayName });
  };

  const handleEmailChange = (e) => {
    setDisplayEmail(e.target.value);
  };

  const handleEmailPress = (e) => {
    if (e.key === "Enter") {
      sendEmailToServer();
    }
  };

  const handleEmailClick = () => {
    sendEmailToServer();
  };

  const sendEmailToServer = () => {
    updateAccount({ email: displayEmail });
  };

  const [showModal, setShowModal] = useState(false);

  const handleOpenCModal = () => {
    setShowModal(true);
  };

  const handleCloseCModal = () => {
    setShowModal(false);
  };

  const textRef = useRef(null);

  const handleCopyClick = () => {};

  const earnedList = ((achData && achData.achievements) || []).filter((a) => a.earned);
  const featuredList = [...earnedList]
    .sort((a, b) => {
      const aOrder = a.featured_order === null || a.featured_order === undefined ? Infinity : a.featured_order;
      const bOrder = b.featured_order === null || b.featured_order === undefined ? Infinity : b.featured_order;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return new Date(b.earned_at || 0) - new Date(a.earned_at || 0);
    })
    .slice(0, MAX_FEATURED);

  const openFeaturedEditor = () => {
    setFeaturedSelection(featuredList.map((a) => a.achievement_id));
    setShowFeaturedEditor(true);
  };

  const toggleFeatured = (achievementId) => {
    setFeaturedSelection((prev) => {
      if (prev.includes(achievementId)) {
        return prev.filter((id) => id !== achievementId);
      }
      if (prev.length >= MAX_FEATURED) {
        toast.error(`حداکثر ${toFarsiNumber(MAX_FEATURED)} نشان می‌تونی انتخاب کنی`);
        return prev;
      }
      return [...prev, achievementId];
    });
  };

  const saveFeatured = async () => {
    setSavingFeatured(true);
    try {
      const resp = await myFetch("achievements/featured", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ achievement_ids: featuredSelection }),
      });
      const r = await resp.json();
      if (r.status === "success") {
        toast.success("نشان‌های ویژه بروزرسانی شد");
        setShowFeaturedEditor(false);
        loadAchievements();
      } else {
        toast.error(r.message || "مشکلی پیش اومد، دوباره امتحان کن");
      }
    } finally {
      setSavingFeatured(false);
    }
  };

  if (!isLoggedIn) {
    return (
      <AccountEmptyState
        title="این حساب کاربریته"
        caption="وارد حسابت شو تا اطلاعات و تراکنش‌هات رو ببینی."
      />
    );
  }

  return (
    <div className="backLightColor">

      <TopNavbarBack
        title=""
        rbuttonIcon={["icon-iconchevron-right"]}
        rbackground={["rectangle1"]}
        lbuttonIcon={["dNone"]}
        lbuttonHref={["null"]}
        lbackground={["null"]}
      />

      <img src={account} alt="account" className="width100 z-index-1" />

      <div className="main-container">
<div className="resFlex">
        <div className="b-white padding5 radius1-5 shadow-smooth">
          <p className="rightAlign yekan purple-1 caption-1">اطلاعات کاربری</p>
          <div className="spc-between">
            <p className="marginTop3 yekan caption-1">نام:</p>
            <input
              type="text"
              value={displayName}
              onChange={handleNameChange}
              onKeyDown={handleNamePress}
              placeholder="چی صدا کنیم تو رو؟"
              className="yekan caption-1"
            />
            <button
              onClick={handleNameClick}
              className={`sendBtn icon-icondone ${dClassName}`}
            ></button>
          </div>
          <div className="spc-between">
            <p className="marginTop3 yekan caption-1">ایمیل:</p>
            <input
              type="email"
              value={displayEmail}
              onChange={handleEmailChange}
              onKeyDown={handleEmailPress}
              placeholder="ایمیلت رو وارد کن"
              className="yekan caption-1"
            />
            <button
              onClick={handleEmailClick}
              className={`sendBtn icon-icondone ${eClassName}`}
            ></button>
          </div>
          <div className="spc-between">
            <p className="marginTop3 yekan caption-1">شماره:</p>
            <input
              type="text"
              value={userInfo.phone_number}
              className="yekan caption-1 b-white"
              disabled
            />
          </div>
        </div>

        {achData && (
          <div className="b-white padding5 radius1-5 shadow-smooth">
            <div className="spc-between">
              <p className="rightAlign yekan purple-1 caption-1">دستاوردها</p>
              <Link to="/achievements" className="caption-2 purple-1 yekan">
                مشاهده همه
              </Link>
            </div>

            <div className="spc-between marginTop5">
              <p className="heading-3 purple-1">
                {toFarsiNumber(achData.total_earned || 0)} / {toFarsiNumber(achData.total_available || 0)}
              </p>
              <p className="heading-3 purple-1">{toFarsiNumber(achData.total_points || 0)} امتیاز</p>
            </div>

            {featuredList.length > 0 ? (
              <div className="featuredBadgeRow marginTop5">
                {featuredList.map((a) => (
                  <AchievementCard
                    key={a.achievement_id}
                    achievement={a}
                    size="sm"
                    onClick={setSelectedAchievement}
                  />
                ))}
              </div>
            ) : (
              <p className="caption-1 grey-2 yekan marginTop5">هنوز دستاوردی کسب نکردی</p>
            )}

            {earnedList.length > 0 && (
              <button
                type="button"
                onClick={openFeaturedEditor}
                className="caption-1 purple-1 yekan marginTop5"
                style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
              >
                ویرایش نشان‌های ویژه
              </button>
            )}
          </div>
        )}

        <div className="b-white padding5 radius1-5 shadow-smooth marginBottom60">
          <p className="rightAlign yekan purple-1 caption-1">تراکنش‌ها</p>
          <Transaction transactions={transactions} handleOpenCModal={handleOpenCModal} setModalData={setModalData}></Transaction>
        </div>
</div>
      </div>

      <Modal
        isOpen={showModal}
        onRequestClose={handleCloseCModal}
        contentLabel="package info"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="b-white radius2 marginBottom0-4r b-grey-5">
          <div className="width100">
            <div className="marginSide10 centerAlign b-white radius1 paddingSide14 marginTop10">
              <h3>{planName}</h3>
              {/* <h5 className="grey-2">فعال تا {endAt}</h5> */}
            </div>
          </div>
          <div className="marginSide10 marginTop10">
            <div
              className="centerAlign spc-between paddingSide5 marginTop5"
              onClick={handleCopyClick}
            >
              <p className="yekan caption-1">کد پیگیری</p>
              <p className="grey-2 yekan caption-1" ref={textRef}>
                {trackId}
              </p>
            </div>
            <div className="centerAlign spc-between paddingSide5 marginTop5">
              <p className="yekan caption-1">تاریخ شروع</p>
              <p className="grey-2 yekan caption-1">{startAt}</p>
            </div>
            <div className="centerAlign spc-between paddingSide5 marginTop5">
              <p className="yekan caption-1">تاریخ پایان</p>
              <p className="grey-2 yekan caption-1">{endAt}</p>
            </div>
            <div className="centerAlign spc-between paddingSide5 marginTop5">
              <p className="yekan caption-1">قیمت نهایی</p>
              <p className="grey-2 yekan caption-1">{price}</p>
            </div>
          </div>
          <img src={network} alt="network" className="width100 padding10" />
        </div>

        <div className="modal-footer">
          <Link
            to=""
            onClick={handleCloseCModal}
            className="b-purple-1 white fill-container radius1-5"
          >
            بستن
          </Link>
        </div>
      </Modal>

      <Modal
        isOpen={showFeaturedEditor}
        onRequestClose={() => setShowFeaturedEditor(false)}
        contentLabel="featured achievements"
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-header">
          <h2>نشان‌های ویژه</h2>
          <a onClick={() => setShowFeaturedEditor(false)}>
            <span className="icon-iconclose rectangle-1 heading-1 grey-3"></span>
          </a>
        </div>
        <div className="modal-body">
          <p className="caption-1 grey-2 yekan rightAlign marginBottom1r">
            تا {toFarsiNumber(MAX_FEATURED)} نشان رو برای نمایش توی پروفایلت انتخاب کن
          </p>
          <div className="achievementGrid">
            {earnedList.map((a) => {
              const selected = featuredSelection.includes(a.achievement_id);
              return (
                <button
                  key={a.achievement_id}
                  type="button"
                  className={`achievementCard achievementCard-sm achievementCard-earned achRarity-${
                    a.rarity || "common"
                  } featuredBadgeToggle ${selected ? "featuredBadgeToggle-selected" : ""}`}
                  onClick={() => toggleFeatured(a.achievement_id)}
                >
                  {selected && <span className="featuredBadgeCheck">✓</span>}
                  <span className="achievementCardIcon" aria-hidden="true">
                    {a.icon && a.icon.trim() ? a.icon : "🏆"}
                  </span>
                  <span className="achievementCardName yekan">{a.name}</span>
                </button>
              );
            })}
          </div>
        </div>
        <div className="modal-footer">
          <a
            className="marginBottom0-4r fill-container radius1-5"
            style={{ opacity: savingFeatured ? 0.6 : 1 }}
            onClick={() => !savingFeatured && saveFeatured()}
          >
            {savingFeatured ? "در حال ذخیره..." : "ذخیره"}
          </a>
        </div>
      </Modal>

      <AchievementModal achievement={selectedAchievement} onClose={() => setSelectedAchievement(null)} />

      <GoToTop />
    </div>
  );
}
